export default __webpack_public_path__ + "static/media/6.d42b56f5.webp";